import { render } from "./ParametersCreate.vue?vue&type=template&id=acc61508&scoped=true"
import script from "./ParametersCreate.vue?vue&type=script&lang=js"
export * from "./ParametersCreate.vue?vue&type=script&lang=js"

import "./ParametersCreate.vue?vue&type=style&index=0&id=acc61508&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acc61508"]])

export default __exports__